/**
 * タグをunicodeに変換する関数
 * @param {string} str
 * @returns {string} 返還後の文字列
 */
export const unicodeEscape = (str: string | null) =>
  str?.replaceAll(/</g, '\u003C').replaceAll(/>/g, '\u003E') || '';
